import React, { useState } from 'react';
import './index.scss';

const CollapsibleSection = ({ title, description, children }: any) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <div className="collapsible-section mb-4">
            <div
                onClick={toggleOpen}
                className="cursor-pointer flex justify-between items-center p-4 bg-white text-black border border-gray-200 rounded-md shadow-sm hover:shadow-md transition-shadow duration-200"
            >
                <h3 className="text-sm font-semibold">{title}</h3>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <div className="p-4 bg-gray-100 rounded-md border border-t-0 border-gray-200">
                    {description && <p className="text-xs text-gray-700 mb-2">{description}</p>}
                    {children}
                </div>
            )}
        </div>
    );
};

const FilterComponent = (props: any) => {
    const [filterName, setFilterName] = useState('');
    const [selectedScore, setSelectedScore] = useState('');
    const [customScore, setCustomScore] = useState('');
    const [isCustomScoreActive, setIsCustomScoreActive] = useState(false);
    const [minuteOption, setMinuteOption] = useState('after');
    const [selectedMinute, setSelectedMinute] = useState('');
    const [isCustomMinuteActive, setIsCustomMinuteActive] = useState(false);
    const [customMinute, setCustomMinute] = useState('');
    const [selectedCards, setSelectedCards] = useState('');
    const [selectedCorners, setSelectedCorners] = useState('');
    const [selectedPossession, setSelectedPossession] = useState('');
    const [selectedShots, setSelectedShots] = useState('');
    const [selectedFouls, setSelectedFouls] = useState('');
    const [selectedBetLine, setSelectedBetLine] = useState('');
    const [selectedOdds, setSelectedOdds] = useState('');
    const [isCustomOddsActive, setIsCustomOddsActive] = useState(false);
    const [customOdds, setCustomOdds] = useState('');
    const [selectedPossessionTeam, setSelectedPossessionTeam] = useState('');

    const handleSave = (e: React.FormEvent) => {
        e.preventDefault();
        // Process filter save logic
    };

    const handleScoreClick = (score: string) => {
        setSelectedScore(score);
        setIsCustomScoreActive(false);
        setCustomScore('');
    };

    const handleCustomScoreClick = () => {
        setIsCustomScoreActive(true);
        setSelectedScore('');
    };

    const handleMinuteClick = (minute: string) => {
        setSelectedMinute(minute);
        setIsCustomMinuteActive(false);
        setCustomMinute('');
    };

    const handleCustomMinuteClick = () => {
        setIsCustomMinuteActive(true);
        setSelectedMinute('');
    };

    const handleOddsClick = (odds: string) => {
        setSelectedOdds(odds);
        setIsCustomOddsActive(false);
        setCustomOdds('');
    };

    const handleCustomOddsClick = () => {
        setIsCustomOddsActive(true);
        setSelectedOdds('');
    };

    return (
        <div className='filter-wrapper'>
            <form onSubmit={handleSave}>
                <div className="p-4 bg-white rounded-md shadow-lg">
                    <h2 className="text-xl font-bold leading-7 text-gray-900 mb-4">Create a New Filter</h2>

                    {/* Filter Name */}
                    <div className="mb-6">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-1">
                            Filter Name
                        </label>
                        <input
                            id="name"
                            name="name"
                            type="text"
                            required
                            value={filterName}
                            onChange={(e) => setFilterName(e.target.value)}
                            className="p-3 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm"
                        />
                    </div>

                    {/* Collapsible Filter Sections */}
                    <CollapsibleSection
                        title="Bet Lines & Expected Odds"
                        description="Select the type of bet line you are interested in and the odds at which you want the filter to trigger."
                    >
                        {/* Bet Lines & Odds Selection */}
                        <div className="grid grid-cols-2 gap-2 mb-4">
                            {['Over/Under', 'Asian Handicap', '1X2', 'Both Teams to Score', 'Correct Score'].map((line) => (
                                <button
                                    key={line}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedBetLine === line ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    } hover:shadow-md transition-shadow duration-200`}
                                    onClick={() => setSelectedBetLine(line)}
                                >
                                    {line}
                                </button>
                            ))}
                        </div>
                        <div className="grid grid-cols-3 gap-2 mb-4">
                            {['1.50', '2.00', '2.50', '3.00', '3.50'].map((odds) => (
                                <button
                                    key={odds}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedOdds === odds ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    } hover:shadow-md transition-shadow duration-200`}
                                    onClick={() => handleOddsClick(odds)}
                                >
                                    {odds}
                                </button>
                            ))}
                            <button
                                type="button"
                                className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                    isCustomOddsActive ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                } hover:shadow-md transition-shadow duration-200`}
                                onClick={handleCustomOddsClick}
                            >
                                Custom
                            </button>
                        </div>
                        {isCustomOddsActive && (
                            <div className="mt-2">
                                <input
                                    type="number"
                                    min={1.0}
                                    step={0.01}
                                    placeholder="Enter custom odds (e.g., 2.75)"
                                    value={customOdds}
                                    onChange={(e) => setCustomOdds(e.target.value)}
                                    className="p-3 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm"
                                />
                            </div>
                        )}
                    </CollapsibleSection>

                    {/* Additional Collapsible Sections */}

                    {/* Collapsible Score Section */}
                    <CollapsibleSection
                        title="Score"
                        description="Choose the predicted final score or enter a custom score to filter games based on the expected outcome."
                    >
                        <div className="grid grid-cols-5 gap-2 mb-4">
                            {['0-0', '1-0', '0-1', '1-1', '2-0', '0-2', '2-1', '1-2', '3-0', '0-3'].map((score) => (
                                <button
                                    key={score}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedScore === score ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    }`}
                                    onClick={() => handleScoreClick(score)}
                                >
                                    {score}
                                </button>
                            ))}
                            <button
                                type="button"
                                className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                    isCustomScoreActive ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                }`}
                                onClick={handleCustomScoreClick}
                            >
                                Custom
                            </button>
                        </div>
                        {isCustomScoreActive && (
                            <div className="mt-2">
                                <input
                                    type="text"
                                    placeholder="Enter custom score (e.g., 4-2)"
                                    value={customScore}
                                    onChange={(e) => setCustomScore(e.target.value)}
                                    className="p-2 block w-full rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        )}
                    </CollapsibleSection>

                    {/* Collapsible Minute Section */}
                    <CollapsibleSection
                        title="Minute"
                        description="Select the game minute range you are interested in, or specify a custom minute to filter games based on key events."
                    >
                        <div className="grid grid-cols-5 gap-2 mb-4">
                            {['10', '20', '30', '40', '50', '60', '70', '80', '90'].map((minute) => (
                                <button
                                    key={minute}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedMinute === minute ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    }`}
                                    onClick={() => handleMinuteClick(minute)}
                                >
                                    {minute}'
                                </button>
                            ))}
                            <button
                                type="button"
                                className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                    isCustomMinuteActive ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                }`}
                                onClick={handleCustomMinuteClick}
                            >
                                Custom
                            </button>
                        </div>
                        {isCustomMinuteActive && (
                            <div className="mt-2">
                                <input
                                    type="number"
                                    min={1}
                                    max={90}
                                    placeholder="Enter custom minute"
                                    value={customMinute}
                                    onChange={(e) => setCustomMinute(e.target.value)}
                                    className="p-2 block w-full rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                            </div>
                        )}
                    </CollapsibleSection>

                    {/* Collapsible Cards Section */}
                    <CollapsibleSection
                        title="Cards"
                        description="Filter matches based on the number of yellow and red cards given in the game."
                    >
                        <div className="grid grid-cols-5 gap-2 mb-4">
                            {['0', '1', '2', '3', '4+'].map((card) => (
                                <button
                                    key={card}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedCards === card ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    }`}
                                    onClick={() => setSelectedCards(card)}
                                >
                                    {card} Cards
                                </button>
                            ))}
                        </div>
                    </CollapsibleSection>

                    {/* Collapsible Corners Section */}
                    <CollapsibleSection
                        title="Corners"
                        description="Choose a range for the number of corner kicks taken during the match."
                    >
                        <div className="grid grid-cols-5 gap-2 mb-4">
                            {['0-4', '5-8', '9-12', '13+'].map((corner) => (
                                <button
                                    key={corner}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedCorners === corner ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    }`}
                                    onClick={() => setSelectedCorners(corner)}
                                >
                                    {corner} Corners
                                </button>
                            ))}
                        </div>
                    </CollapsibleSection>
                    {/* Collapsible Possession Section */}
                    <CollapsibleSection
                        title="Possession"
                        description="Filter games based on the percentage of ball possession for a particular team."
                    >
                        {/* Team Selection for Possession */}
                        <div className="mb-4">
                            <h4 className="text-sm font-medium text-gray-700 mb-2">Select Team:</h4>
                            <div className="grid grid-cols-2 gap-2 mb-4">
                                {['Home', 'Away'].map((team) => (
                                    <button
                                        key={team}
                                        type="button"
                                        className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                            selectedPossessionTeam === team ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                        }`}
                                        onClick={() => setSelectedPossessionTeam(team)}
                                    >
                                        {team}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Possession Percentage Selection */}
                        <div>
                            <h4 className="text-sm font-medium text-gray-700 mb-2">Select Possession Percentage:</h4>
                            <div className="grid grid-cols-5 gap-2 mb-4">
                                {['<40%', '40-50%', '51-60%', '61-70%', '71%+'].map((possession) => (
                                    <button
                                        key={possession}
                                        type="button"
                                        className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                            selectedPossession === possession ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                        }`}
                                        onClick={() => setSelectedPossession(possession)}
                                    >
                                        {possession}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </CollapsibleSection>


                    {/* Collapsible Shots Section */}
                    <CollapsibleSection
                        title="Shots"
                        description="Filter matches by the number of shots taken by both teams during the game."
                    >
                        <div className="grid grid-cols-5 gap-2 mb-4">
                            {['0-5', '6-10', '11-15', '16-20', '21+'].map((shots) => (
                                <button
                                    key={shots}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedShots === shots ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    }`}
                                    onClick={() => setSelectedShots(shots)}
                                >
                                    {shots} Shots
                                </button>
                            ))}
                        </div>
                    </CollapsibleSection>

                    {/* Collapsible Fouls Section */}
                    <CollapsibleSection
                        title="Fouls"
                        description="Select a range for the number of fouls committed during the match."
                    >
                        <div className="grid grid-cols-5 gap-2 mb-4">
                            {['0-5', '6-10', '11-15', '16-20', '21+'].map((fouls) => (
                                <button
                                    key={fouls}
                                    type="button"
                                    className={`p-2 rounded-md border border-gray-300 text-sm font-medium ${
                                        selectedFouls === fouls ? 'bg-indigo-600 text-white' : 'bg-white text-gray-900'
                                    }`}
                                    onClick={() => setSelectedFouls(fouls)}
                                >
                                    {fouls} Fouls
                                </button>
                            ))}
                        </div>
                    </CollapsibleSection>

                    <div className="mt-6 p-4 border border-gray-300 rounded-md bg-gray-50">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Summary {filterName}</h3>
                        <div className="grid grid-cols-2 gap-4">
                            {/* Bet Line and Odds */}
                            {selectedBetLine && (
                                <div className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">{selectedBetLine}</p>
                                        <p className="text-xs text-gray-500">Bet Line: {selectedOdds || customOdds}</p>
                                    </div>
                                    <div className="text-right">
                                        <span className="text-sm font-semibold text-indigo-600">{selectedOdds || customOdds}</span>
                                    </div>
                                    <button
                                        className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full bg-transparent hover:bg-red-100 text-gray-500 hover:text-red-600 transition-colors duration-200"
                                        onClick={() => setSelectedBetLine('')}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Score */}
                            {selectedScore && (
                                <div className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Score</p>
                                        <p className="text-xs text-gray-500">Predicted: {selectedScore || customScore}</p>
                                    </div>
                                    <button
                                        className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full bg-transparent hover:bg-red-100 text-gray-500 hover:text-red-600 transition-colors duration-200"
                                        onClick={() => {
                                            setSelectedScore('');
                                            setCustomScore('');
                                            setIsCustomScoreActive(false);
                                        }}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Minute */}
                            {(selectedMinute || customMinute) && (
                                <div
                                    className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Minute</p>
                                        <p className="text-xs text-gray-500">{minuteOption}: {selectedMinute || customMinute}</p>
                                    </div>
                                    <button
                                        className="absolute top-1 right-1 text-gray-500 hover:text-red-500 text-xs"
                                        onClick={() => {
                                            setSelectedMinute('');
                                            setCustomMinute('');
                                            setIsCustomMinuteActive(false);
                                        }}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Cards */}
                            {selectedCards && (
                                <div
                                    className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Cards</p>
                                        <p className="text-xs text-gray-500">Total: {selectedCards}</p>
                                    </div>
                                    <button
                                        className="absolute top-1 right-1 text-gray-500 hover:text-red-500 text-xs"
                                        onClick={() => setSelectedCards('')}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Corners */}
                            {selectedCorners && (
                                <div
                                    className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Corners</p>
                                        <p className="text-xs text-gray-500">Total: {selectedCorners}</p>
                                    </div>
                                    <button
                                        className="absolute top-1 right-1 text-gray-500 hover:text-red-500 text-xs"
                                        onClick={() => setSelectedCorners('')}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Possession */}
                            {selectedPossession && (
                                <div
                                    className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Possession</p>
                                        <p className="text-xs text-gray-500">{selectedPossessionTeam} Team: {selectedPossession}</p>
                                    </div>
                                    <button
                                        className="absolute top-1 right-1 text-gray-500 hover:text-red-500 text-xs"
                                        onClick={() => {
                                            setSelectedPossession('');
                                            setSelectedPossessionTeam('');
                                        }}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Shots */}
                            {selectedShots && (
                                <div
                                    className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Shots</p>
                                        <p className="text-xs text-gray-500">Total: {selectedShots}</p>
                                    </div>
                                    <button
                                        className="absolute top-1 right-1 text-gray-500 hover:text-red-500 text-xs"
                                        onClick={() => setSelectedShots('')}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}

                            {/* Fouls */}
                            {selectedFouls && (
                                <div
                                    className="relative flex justify-between items-center border border-gray-200 p-2 rounded-md bg-white shadow">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">Fouls</p>
                                        <p className="text-xs text-gray-500">Total: {selectedFouls}</p>
                                    </div>
                                    <button
                                        className="absolute top-1 right-1 text-gray-500 hover:text-red-500 text-xs"
                                        onClick={() => setSelectedFouls('')}
                                    >
                                        <span className="material-icons text-sm">close</span>
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Save and Cancel Buttons */}
                        <div className="mt-6 flex justify-center space-x-4">
                            <button
                                type="submit"
                                className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-md hover:bg-indigo-500 transition-colors duration-200"
                            >
                                Looks Good, Save
                            </button>
                            <button
                                type="button"
                                className="text-sm font-semibold leading-6 text-gray-900"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FilterComponent;
